const getters = {
  ticketsToManage: (state) => state.tickets,
  fetchedFromOtherModule: (state) => state.fetchedFromOtherModule,
  clientsIdFilterTicket: (state) => state.clientsIdFilterTicket,
  rangeFilterTickets: (state) => state.rangeFilterTickets,
}

export default getters
